"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    get: function get(object, key, propName) {
        // For history!
        propName = propName || "com.wix.restaurants";
        var obj = JSON.parse((object.properties || {})[propName] || "{}");

        var parts = key.split(".");
        while (parts.length > 0) {
            var part = parts.shift();

            if (part.substr(0, 1) === "?") {
                return _lodash2.default.includes(obj || [], part.substr(1));
            } else {
                obj = (obj || {})[part];
            }
        }

        return obj;
    },

    getOrgs: function getOrgs(orgs, key) {
        for (var i = 0, l = orgs.length; i < l; i++) {
            if (orgs[i]) {
                var value = this.get(orgs[i], key);
                if (typeof value !== "undefined") {
                    return value;
                }
            }
        }

        return null;
    },

    set: function set(object, key, value, propName) {
        // For history!
        propName = propName || "com.wix.restaurants";
        object.properties = object.properties || {};

        var parent = null;
        var lastPart = null;

        var obj = JSON.parse(object.properties[propName] || "{}");
        var top = obj;

        var arrayVal = null;
        var parts = key.split(".");
        while (parts.length > 0) {
            var part = parts.shift();

            if (part.substr(0, 1) === "?") {
                arrayVal = part.substr(1);
                obj = _lodash2.default.isEmpty(obj) ? [] : obj;
            } else {
                lastPart = part;
                parent = obj;
                obj[part] = obj[part] || {};
                obj = obj[part];
            }
        }

        if (!parent) {
            throw "Error";
        }

        if (arrayVal) {
            parent[lastPart] = value ? _lodash2.default.union(obj, [arrayVal]) : _lodash2.default.without(obj, arrayVal);
        } else {
            parent[lastPart] = value;
        }
        object.properties[propName] = (0, _stringify2.default)(top);
    }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/Properties.js
// module id = 78
// module chunks = 0